// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__TnIBo","fadeInOut":"styles_fadeInOut__vp2C7","loader":"styles_loader__UhLzF"};